import { initAccordions } from 'components/accordions'

initAccordions({ isClosingOthers: true })
